import {
    EventInteractions,
    EventsInteractionsTracker,
    InteractionsLoggerV1,
    InteractionsLoggerV2,
    InteractionsStatsigLogger,
} from '@eventbrite/event-tracker';
import { parseQuery } from 'url-lib';

interface TrackingFeatureFlags {
    enable_tracking_v2_global: boolean;
    enable_redirect_tracking_to_v2: boolean;
}

export function startEventCardsTracking(featureFlags: TrackingFeatureFlags) {
    const eventInteractionTracker = new EventsInteractionsTracker(
        document,
        getActiveLoggersBasedOn(featureFlags),
    );
    eventInteractionTracker.listen();
    eventInteractionTracker.track();
}

function getActiveLoggersBasedOn(featureFlags: TrackingFeatureFlags) {
    const commonLoggers = [new InteractionsStatsigLogger()];

    if (featureFlags?.enable_tracking_v2_global) {
        return [
            new InteractionsLoggerV1(),
            new InteractionsLoggerV2(),
            ...commonLoggers,
        ];
    }

    if (featureFlags?.enable_redirect_tracking_to_v2) {
        return [new InteractionsLoggerV2(), ...commonLoggers];
    } else {
        return [new InteractionsLoggerV1(), ...commonLoggers];
    }
}

export function broadcastOpenEvent(eventId: string) {
    const queryParams = parseQuery(window.location.search);
    const channelId = queryParams.from;

    // If Broadcast channel is not supported just ignore these events
    // If no channelId is provided, ignore this
    if (
        typeof BroadcastChannel === 'undefined' ||
        !channelId ||
        typeof channelId !== 'string'
    ) {
        return undefined;
    }

    const channel = new BroadcastChannel(channelId);
    channel.postMessage({
        action: EventInteractions.OpenExternal,
        id: eventId,
    });
    channel.close();
}
